import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';
import { Icon } from '@iconify/react';

const Appointment = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    department: '',
    msg: ''
  });

  const departmentLabels = {
    'consulta-medica': 'Consulta Médica y Especialidades',
    'diagnostico-imagenes': 'Diagnóstico por Imágenes',
    'rehabilitacion': 'Terapias y Rehabilitación',
    'atencion-domiciliaria': 'Atención Domiciliaria',
    'odontologia': 'Odontología',
    'sgsst': 'Salud en el Trabajo',
  };

  const handleInputChange = event => {
    const { name, value } = event.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const selectedService = departmentLabels[formData.department] || "Servicio";
    const subject = `Solicitud de Cita - ${selectedService} - ${formData.name}`;

    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("phone", formData.phone);
    formDataToSend.append("date", formData.date);
    formDataToSend.append("department", selectedService);
    formDataToSend.append("msg", formData.msg);
    formDataToSend.append("from_name", "Cita Fisioters SAS");
    formDataToSend.append("replyto", "admision@fisioters.com");
    formDataToSend.append("to", "admision@fisioters.com");
    formDataToSend.append("subject", subject);

    try {
      const response = await fetch("/cita.php", {
        method: "POST",
        body: formDataToSend
      });

      const text = await response.text();
      console.log(text);

      alert("✅ Solicitud enviada correctamente.");
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        department: '',
        msg: ''
      });
    } catch (error) {
      console.error("❌ Error al enviar:", error);
      alert("Ocurrió un error. Inténtalo más tarde.");
    }

    setLoading(false);
  };

  return (
    <section id="appointment" className="st-shape-wrap st-gray-bg">
      <div className="st-shape4">
        <img src="/shape/section_shape.png" alt="Decoración" />
      </div>
      <div className="st-shape6">
        <img src="/shape/contact-shape3.svg" alt="Decoración" />
      </div>
      <div className="st-height-b120 st-height-lg-b80" />
      <SectionHeading
        title="Solicita tu cita"
        subTitle="Agenda tu atención en cualquiera de nuestros servicios médicos y recibe un acompañamiento personalizado."
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <form
              method="POST"
              className="st-appointment-form"
              id="appointment-form"
              onSubmit={onSubmit}
            >
              <div className="row">
                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Nombre completo</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Ej. Juan Pérez"
                      onChange={handleInputChange}
                      value={formData.name}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Correo electrónico</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="correo@ejemplo.com"
                      onChange={handleInputChange}
                      value={formData.email}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Teléfono</label>
                    <input
                      type="text"
                      name="phone"
                      placeholder="+57 310 1234567"
                      onChange={handleInputChange}
                      value={formData.phone}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Fecha de la cita</label>
                    <input
                      name="date"
                      type="date"
                      placeholder="dd/mm/aaaa"
                      onChange={handleInputChange}
                      value={formData.date}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="st-form-field st-style1">
                    <label>Servicio</label>
                    <div className="st-custom-select-wrap">
                      <select
                        name="department"
                        className="st_select1"
                        onChange={handleInputChange}
                        value={formData.department}
                        required
                      >
                        <option value="">Selecciona un servicio</option>
                        <option value="consulta-medica">Consulta Médica y Especialidades</option>
                        <option value="diagnostico-imagenes">Diagnóstico por Imágenes</option>
                        <option value="rehabilitacion">Terapias y Rehabilitación</option>
                        <option value="atencion-domiciliaria">Atención Domiciliaria</option>
                        <option value="odontologia">Odontología</option>
                        <option value="sgsst">Salud en el Trabajo</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="st-form-field st-style1">
                    <label>Mensaje</label>
                    <textarea
                      name="msg"
                      rows={6}
                      placeholder="Escribe tu solicitud o consulta..."
                      onChange={handleInputChange}
                      value={formData.msg}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <button
                    className="st-btn st-style1 st-color1 st-size-medium"
                    type="submit"
                  >
                    {loading ? "Enviando..." : "Solicitar Cita"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Appointment;